import { useContext, useEffect, useState } from "react";
import apiRequest from "../../../../services/apiRequest";
import AuthenticationService from "../../../../services/AuthenticationService";
import { NotificationsContext } from "../../../Notifications";

const useRoles = () => {
  const [userScopes] = useState(AuthenticationService.getUserScopes());
  const [roles, setRoles] = useState(null);
  const { push } = useContext(NotificationsContext);

  useEffect(() => {
    let closed = false;
    const fetchRoles = async () => {
      try {
        const data = await apiRequest.get("/roles");

        if (typeof data !== "object") {
          throw new Error("not object");
        }

        if (!closed) {
          setRoles(data);
        }
      } catch (error) {
        if (!closed) {
          push({
            title: "Errore durante il caricamento",
            type: "error",
          });
        }
      }
    };

    if (roles === null) {
      if (userScopes.indexOf("role:read") >= 0) {
        fetchRoles();
      } else {
        setRoles(false);
        push({
          title: "Scope role:read non trovato",
          type: "error",
          fixed: true,
        });
      }
    }

    return () => {
      closed = true;
    };
  }, [userScopes, roles, push]);

  return roles;
};

export default useRoles;
